import React, { PropsWithChildren } from 'react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { getConfig } from '../utils/get-config';

type Props = PropsWithChildren<{}>;

export const PayPalProvider: React.FC<Props> = ({ children }) => {
  const clientId = getConfig('REACT_APP_PAYPAL_CLIENT_ID');

  if (!clientId) {
    return <>{children}</>;
  }

  return (
    <PayPalScriptProvider
      deferLoading={true}
      options={{
        clientId,
        intent: 'capture',
        components: 'buttons',
      }}
    >
      {children}
    </PayPalScriptProvider>
  );
};
